import { getDefaultWeekRange } from "hybridspace-common/lib/context";
import { getUserWeekStartDay } from "hybridspace-common/lib/utils";
import { setCurrentDate as setCurrentAgendaDate } from "hybridspace-places-finder-store";
import { today, userDate } from "owa-datetime";
import { createWeekDateRange } from "owa-datetime-utils";
import { setCurrentDate, updateCurrentDateRange } from "places-user-session-stores";

import type { OwaDate } from "owa-datetime";
import type { LoaderFunction } from "react-router-dom";

export const setPeopleDate: LoaderFunction = async ({ request }) => {
    const url = new URL(request.url);
    const startDateParam = url.searchParams.get("date");
    
    if (!startDateParam) {
        return setDatesToDefault();
    }
    
    const date = getDateFromStartDate(startDateParam);
    
    // set date and dateRange, but only if the calculation yielded a result.
    if (date) {
        setCurrentDate(date);
        
        const dateRange = createWeekDateRange(getUserWeekStartDay(), date);
        updateCurrentDateRange(dateRange);
        
        setCurrentAgendaDate(date);
    }
    else {
        setDatesToDefault();
    }
    
    return null;
};

function setDatesToDefault() {
    setCurrentDate(today());
    
    updateCurrentDateRange(getDefaultWeekRange());
    
    setCurrentAgendaDate(today());
    
    return null;
}

function getDateFromStartDate(startDateParam: string | null): OwaDate | null {
    if (!startDateParam) {
        return null;
    }
    
    try {
        return userDate(startDateParam);
    }
    catch {
        return null;
    }
}
